// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { InvoicingQueries } from '../../../../types/server/modules/invoicing/queries';

export type * from '../../../../types/server/modules/invoicing/queries';

export const createQueries = ( requests: Requests ): InvoicingQueries => ({
  BillingEntitiesById: ( id, query, headers ) => { 
          return requests.get( `/billing-entities/${id}`, query, headers ); 
        },
  BillingEntities: ( params?, headers? ) => {
        return requests.get( `/billing-entities/:id?`, params, headers );
      },
  FiscalDocumentsById: ( id, query, headers ) => { 
          return requests.get( `/fiscal-documents/${id}`, query, headers ); 
        },
  FiscalDocuments: ( params?, headers? ) => {
        return requests.get( `/fiscal-documents/:id?`, params, headers );
      },
  InvoicingTaxpayerRegistry: ( params?, headers? ) => {
        return requests.get( `/invoicing/taxpayer-registry`, params, headers );
      },
  InvoicingBuyerInvoicePreferencesById: ( id, query, headers ) => { 
          return requests.get( `/invoicing/buyer-invoice-preferences/${id}`, query, headers ); 
        },
  InvoicingBuyerInvoicePreferences: ( params?, headers? ) => {
        return requests.get( `/invoicing/buyer-invoice-preferences/:id?`, params, headers );
      }
});
